import { render, staticRenderFns } from "./wcwaiver.vue?vue&type=template&id=07be379c"
import script from "./wcwaiver.vue?vue&type=script&lang=js"
export * from "./wcwaiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports